import { window } from 'window';

export const getTyroolaGlobals = () =>
    window.TYROOLA.globals;
